import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import DashHeader from "./DashHeader";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";

function InvestmentDueDiligence() {
  const [formStep, setFormStep] = useState(1);

  const { userInfo } = useSelector((state) => state.userLogin);

  const smeDetails = useSelector((state) => state.userSMEDetails);
  const { sme } = smeDetails;

  const formik = useFormik({
    initialValues: {
      formType: "due_diligence",
      haveMoi: false,
      multipleShare: false,
      shareAgreement: false,
      domain: false,
      registeredDomain: false,
      ipValue: false,
      docIpProtection: false,
      website: false,
      docFinancialStatements: false,
      docManagementAccounts: false,
      annualTax: false,
      haveEmployees: false,
      regPaye: false,
      regUIF: false,
      empID: false,
      regVat: false,
      bankAccount: false,
      bankVerification: false,
      bankStatement: false,
      loanAgreements: false,
      directors: false,
      directorsCompliant: false,
      capTable: false,
      orgChart: false,
      salarySchedule: false,
      execContact: false,
      execCv: false,
      pitchDeck: false,
      finForecasts: false,
      viabilityForecast: false,
      clientContact: false,
      clientContract: false,
      businessCaseStudy: false,
      solutionSamples: false,
      supplyOverview: false,
      supplyContact: false,
      systemDiagram: false,
      websiteTos: false,
      websitePp: false,
      toolData: false,
      toolSales: false,
      toolMarketing: false,
      toolBilling: false,
    },
    onSubmit: (values) => {
      const api_secret_key = "TDNMSwa7U1p56gg6gEnH";
      const doctype_id = "LACOONA - DUE DILIGENCE";
      const allValues = values;

      allValues["userId"] = userInfo.id;
      allValues["company_id"] = userInfo.email;
      allValues["doctype_id"] = doctype_id;
      allValues["company_name"] = sme.name;
      allValues["name"] = userInfo.name;

      const pdfMonkeyConfig = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${api_secret_key}`,
        },
      };
      setFormStep((formStep) => formStep + 1);
      axios
        .post(
          "https://api.pdfmonkey.io/api/v1/documents/",
          {
            document: {
              document_template_id: "DF6FCF37-6A87-4770-BFB2-56A7C26E9B17",
              payload: allValues,
              status: "pending",
            },
          },
          pdfMonkeyConfig
        )
        .then(function (response) {
          console.log("Response Received");
        })
        .catch(function (error) {
          console.log("Error Occured");
        });
    },
    validationSchema: Yup.object({}),
  });

  function setNextFormStep() {
    setFormStep((formStep) => formStep + 1);
  }

  function setPreviousFormStep() {
    setFormStep((formStep) => formStep - 1);
  }

  return (
    <Col className="dashboard-scrollable-container" lg={9}>
      <Helmet>
        <title>Investment Due Diligence</title>
        <meta
          name="description"
          content="Lacoona Legal helps you ensure POPI compliance ."
        />
        <link rel="canonical" href="/dashboard/popi" />
      </Helmet>
      <DashHeader pageTitle={"POPI Compliance Guidance"} />
      <Row className="dashboard-content-container">
        <Row className="find-lawyer-hero px-5">
          <Col lg={8} className="">
            <LinkContainer to={"/dashboard/legal-checks"}>
              <button className="lcn-button-orange py-2 px-4">Back</button>
            </LinkContainer>
            <Row className="due-diligence-header">
              <h1 className="serious-font">Investment Due Diligence</h1>
            </Row>
            <Row>
              <p>
                Complete the form to get a Investment Due Diligence assessment
                mailed to your inbox.
              </p>
            </Row>
          </Col>
        </Row>

        <Row className="health-check-form-categories">
          <Col
            onClick={() => setFormStep(1)}
            className={formStep === 1 ? "active-tab" : "tab"}
          >
            <div>Company and Financial</div>
          </Col>
          <Col
            onClick={() => setFormStep(2)}
            className={formStep === 2 ? "active-tab" : "tab"}
          >
            <div>Team and Planning</div>
          </Col>
          <Col
            onClick={() => setFormStep(3)}
            className={formStep === 3 ? "active-tab" : "tab"}
          >
            <div>Suppliers and Processes</div>
          </Col>
          {/*  <Col
            onClick={() => setFormStep(3)}
            className={formStep === 3 ? "active-tab" : "tab"}
          >
            <div>Steps to Resolution</div>
          </Col> */}
        </Row>
        <Row className="find-a-lawyer-form-container">
          {formStep === 1 && (
            <Col className="form-step" lg={8}>
              <Row>
                <h4 className="form-step-heading">Company and IP</h4>
              </Row>
              <Form>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a Memorandum of Incorporation (MOI)?
                  </p>
                  <Form.Check
                    className={
                      formik.values.haveMoi === true &&
                      "form-check-input:checked"
                    }
                    type="switch"
                    id="custom-switch"
                    value={formik.values.haveMoi}
                    name="haveMoi"
                    onChange={formik.handleChange}
                  />
                </div>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you more than one shareholder?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.multipleShare}
                    name="multipleShare"
                    onChange={formik.handleChange}
                  />
                </div>
                {formik.values.multipleShare === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Your company has more than one shareholder and needs to
                      have a Shareholder's Agreement. Do you have a
                      Shareholder's Agreement?
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.shareAgreement}
                      name="shareAgreement"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have any trademarks, patents, design registration or
                    copyright?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.ipValue}
                    name="ipValue"
                    onChange={formik.handleChange}
                  />
                </div>

                {formik.values.multipleShare === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Has your company registered its trade mark(s)?
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.docIpProtection}
                      name="docIpProtection"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">Do you own your own domain?</p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.domain}
                    name="domain"
                    onChange={formik.handleChange}
                  />
                </div>

                {formik.values.multipleShare === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Has your company registered its domain?
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.registeredDomain}
                      name="registeredDomain"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}

                {/* Financial Section */}
                <Row>
                  <h4 className="form-step-heading py-3">Financial</h4>
                </Row>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have annual financial statements?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.docFinancialStatements}
                    name="docFinancialStatements"
                    onChange={formik.handleChange}
                  />
                </div>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">Do you keep management accounts?</p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.docManagementAccounts}
                    name="docManagementAccounts"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you submit your annual tax returns?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.annualTax}
                    name="annualTax"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">Do you have employees?</p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.haveEmployees}
                    name="haveEmployees"
                    onChange={formik.handleChange}
                  />
                </div>

                {formik.values.haveEmployees === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Do you deduct PAYE from employee's income and submit
                      returns to SARS?
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.regPaye}
                      name="regPaye"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}
                {formik.values.haveEmployees === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Do you deduct and submit UIF contributions to SARS?
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.regUIF}
                      name="regUIF"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}
                {formik.values.haveEmployees === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Do you keep copies of all employee's IDs?
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.empID}
                      name="empID"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Are you registered with SARS for VAT?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.regVat}
                    name="regVat"
                    onChange={formik.handleChange}
                  />
                </div>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Does your business have a bank account?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.bankAccount}
                    name="bankAccount"
                    onChange={formik.handleChange}
                  />
                </div>

                {formik.values.bankAccount === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Do you have a bank verification letter? This confirms that
                      your company has an account at that bank.
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.bankVerification}
                      name="bankVerification"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}

                {formik.values.haveEmployees === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Do you get regular bank statements?
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.bankStatement}
                      name="bankStatement"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">Do you have any loan agreements?</p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.loanAgreements}
                    name="loanAgreements"
                    onChange={formik.handleChange}
                  />
                </div>
              </Form>
              <Row>
                <Col></Col>

                <Col className="form-step-next-button-container">
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={setNextFormStep}
                  >
                    Next
                  </button>
                </Col>
              </Row>
            </Col>
          )}

          {formStep === 2 && (
            <Col className="form-step" lg={8}>
              <Row>
                <h4 className="form-step-heading">Team</h4>
              </Row>
              <Form>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Does your company have one or more directors?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.directors}
                    name="directors"
                    onChange={formik.handleChange}
                  />
                </div>

                {formik.values.directors === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Are all directors appointed according to the requirements
                      of your company MOI and have the appointments been
                      reported to CIPC?
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.directorsCompliant}
                      name="directorsCompliant"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a capitilisation (cap) table?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.capTable}
                    name="capTable"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have an organisational chart?{" "}
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.orgChart}
                    name="orgChart"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a schedule of salaries?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.salarySchedule}
                    name="salarySchedule"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have the contact details of all your executive?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.execContact}
                    name="execContact"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have the CVs of all your executive?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.execCv}
                    name="execCv"
                    onChange={formik.handleChange}
                  />
                </div>

                <Row>
                  <h4 className="form-step-heading py-3">Planning</h4>
                </Row>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a pitch deck for your company?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.pitchDeck}
                    name="pitchDeck"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have the CVs of all your executive?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.execCv}
                    name="execCv"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have financial forecasts for your business?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.finForecasts}
                    name="finForecasts"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a commercial and investment viability forecast?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.viabilityForecast}
                    name="viabilityForecast"
                    onChange={formik.handleChange}
                  />
                </div>
              </Form>

              <Row>
                <Col>
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={setPreviousFormStep}
                  >
                    Back
                  </button>
                </Col>
                <Col className="form-step-next-button-container">
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={setNextFormStep}
                  >
                    Next
                  </button>
                </Col>
              </Row>
            </Col>
          )}

          {formStep === 3 && (
            <Col className="form-step" lg={8}>
              <Row>
                <h4 className="form-step-heading">Clients</h4>
              </Row>
              <Form>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a list of your clients and their contact
                    details?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.clientContact}
                    name="clientContact"
                    onChange={formik.handleChange}
                  />
                </div>

                {formik.values.directors === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Do you have written contracts with all your clients?
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.clientContract}
                      name="clientContract"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a business case-study?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.businessCaseStudy}
                    name="businessCaseStudy"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">Do you have solution samples? </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.solutionSamples}
                    name="solutionSamples"
                    onChange={formik.handleChange}
                  />
                </div>

                <Row>
                  <h4 className="form-step-heading py-3">Supply Chain</h4>
                </Row>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have an overview of your company supply chain?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.supplyOverview}
                    name="supplyOverview"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a list of your suppliers and their contact
                    details?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.supplyContact}
                    name="supplyContact"
                    onChange={formik.handleChange}
                  />
                </div>

                <Row>
                  <h4 className="form-step-heading py-3">
                    Process and Systems
                  </h4>
                </Row>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a diagram of your company's system architecture?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.systemDiagram}
                    name="systemDiagram"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">Do you have a website?</p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.website}
                    name="website"
                    onChange={formik.handleChange}
                  />
                </div>

                {formik.values.website === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Does your company have a Website Terms and Conditions
                      Policy?
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.websiteTos}
                      name="websiteTos"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}

                {formik.values.website === true && (
                  <div className="find-a-lawyer-form-question">
                    <p className="col-5 mx-3">
                      Does your company have a Website Privacy Policy?
                    </p>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      value={formik.values.websitePp}
                      name="websitePp"
                      onChange={formik.handleChange}
                    />
                  </div>
                )}

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do have a data management system?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.toolData}
                    name="toolData"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a system to monitor sales?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.toolSales}
                    name="toolSales"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a marketing and sales system?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.toolMarketing}
                    name="toolMarketing"
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    Do you have a system for billing clients?
                  </p>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    value={formik.values.toolBilling}
                    name="toolBilling"
                    onChange={formik.handleChange}
                  />
                </div>
              </Form>

              <Row>
                <Col>
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={setPreviousFormStep}
                  >
                    Back
                  </button>
                </Col>
                <Col className="form-step-next-button-container">
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={formik.submitForm}
                    type="submit"
                  >
                    Submit
                  </button>
                </Col>
              </Row>
            </Col>
          )}
        </Row>

        {formStep === 4 && (
          <Col className="form-step" lg={12}>
            <Row>
              <h4 className="form-step-heading text-center">
                Thank you for your submission. You will receive your Due
                Diligence assessment feedback in your mailbox.
              </h4>
            </Row>
          </Col>
        )}
      </Row>
    </Col>
  );
}

export default InvestmentDueDiligence;
